import Logo from "../../assets/images/svg/logo-coloured.svg";

const AuthLayout = ({children}) => (
  <div className="page main-signin-wrapper">
    <div className="row signpages text-center">
      <div className="col-md-12">
        <div className="w-100"><img src={Logo} alt="Logo" width="250"/></div>
        {children}
      </div>
    </div>
  </div>
)

export default AuthLayout;
